import { render } from "./PasskeyRecord.vue?vue&type=template&id=60677269&scoped=true"
import script from "./PasskeyRecord.vue?vue&type=script&lang=js"
export * from "./PasskeyRecord.vue?vue&type=script&lang=js"

import "./PasskeyRecord.vue?vue&type=style&index=0&id=60677269&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60677269"]])

export default __exports__